import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { IsActiveMatchOptions } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BxHorizontalNavigationComponent } from '@core/components/navigation/horizontal/horizontal.component';
import { BxNavigationService } from '@core/components/navigation/navigation.service';
import { CBNavigationItem } from '@core/components/navigation/navigation.types';
import { UtilsService } from '@core/services/utils/utils.service';
import { environment } from 'environments/environment';
import { geolocalizationService } from '@core/services/geolocalization';
@Component({
    selector: 'cb-horizontal-navigation-basic-item',
    templateUrl: './basic.component.html',
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BxHorizontalNavigationBasicItemComponent implements OnInit, OnDestroy {
    @Input() item: CBNavigationItem;
    @Input() name: string;

    isActiveMatchOptions: IsActiveMatchOptions;
    hiddenPath: boolean = environment.hiddenPath;
    private _bxHorizontalNavigationComponent: BxHorizontalNavigationComponent;
    private _unsubscribeBsc: Subject<void> = new Subject();

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _bxNavigationService: BxNavigationService,
        private _utilsService: UtilsService,
        private _geoS: geolocalizationService

    ) {
        // Set the equivalent of {exact: false} as default for active match options.
        // We are not assigning the item.isActiveMatchOptions directly to the
        // [routerLinkActiveOptions] because if it's "undefined" initially, the router
        // will throw an error and stop working.
        this.isActiveMatchOptions = this._utilsService.subsetMatchOptions;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    putCodeInWS(item) { this._geoS.putGeoInWS(item.codeScreen) }
    /**
     * On init
     */
    ngOnInit(): void {
        // Set the "isActiveMatchOptions" either from item's
        // "isActiveMatchOptions" or the equivalent form of
        // item's "exactMatch" option
        this.isActiveMatchOptions =
            this.item.isActiveMatchOptions ?? this.item.exactMatch
                ? this._utilsService.exactMatchOptions
                : this._utilsService.subsetMatchOptions;

        // Get the parent navigation component
        this._bxHorizontalNavigationComponent = this._bxNavigationService.getComponent(this.name);

        // Mark for check
        this._changeDetectorRef.markForCheck();

        // Subscribe to onRefreshed on the navigation component
        this._bxHorizontalNavigationComponent.onRefreshed.pipe(
            takeUntil(this._unsubscribeBsc)
        ).subscribe(() => {

            // Mark for check
            this._changeDetectorRef.markForCheck();
        });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeBsc.next();
        this._unsubscribeBsc.complete();
    }
}
